<div class="center">
    <label class="ckbox cursor-pointer"><input #check type="checkbox" [readonly]="readonly" [checked]="value" (change)="!readonly ? emitValue(check.checked) : {}"><span></span></label>
</div>